import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "@angular/common";
import * as i3 from "../../shared/directive/tooltip-on-ellipsis-v2.directive";
import * as i4 from "../icon-v2/icon.component";
import * as i5 from "ngx-skeleton-loader";
import * as i6 from "primeng/tooltip";
import * as i7 from "../link-v2/link-v2.component";
import * as i8 from "../side-modal-v2/side-modal-v2.component";
const _c0 = ["*"];
const _c1 = a0 => ({
  "geaui-sidebar-grid": a0
});
const _c2 = () => ({
  height: "30px",
  width: "200px",
  margin: 0
});
const _c3 = () => ({
  height: "30px",
  width: "100px",
  margin: "0 25px"
});
function PageHeaderComponent_geaui_icon_v2_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 13);
    i0.ɵɵlistener("click", function PageHeaderComponent_geaui_icon_v2_4_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.backArrowClicked.emit());
    });
    i0.ɵɵelementEnd();
  }
}
function PageHeaderComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("pTooltip", ctx_r2.pageTitle);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r2.pageTitle), " ");
  }
}
function PageHeaderComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function PageHeaderComponent_Conditional_6_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.openHelp());
    });
    i0.ɵɵelementStart(1, "geaui-icon-v2", 16)(2, "geaui-link-v2", 17);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "X.BUTTON.LEARN_MORE"), " ");
  }
}
function PageHeaderComponent_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function PageHeaderComponent_div_9_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.suffixIconClicked.emit());
    });
    i0.ɵɵelement(1, "geaui-icon-v2", 20);
    i0.ɵɵelementStart(2, "div", 21);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("fileSize", 16)("file", ctx_r2.suffixIcon.file)("color", ctx_r2.suffixIcon.color);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, ctx_r2.suffixIcon == null ? null : ctx_r2.suffixIcon.label));
  }
}
function PageHeaderComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PageHeaderComponent_div_9_div_1_Template, 5, 6, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const iconLoading_r6 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.suffixIconLoading)("ngIfElse", iconLoading_r6);
  }
}
function PageHeaderComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 22);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2));
  }
}
function PageHeaderComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 22);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c3));
  }
}
export class PageHeaderComponent {
  translateService;
  pageTitle;
  hasBackArrow = true;
  suffixIcon;
  suffixIconLoading = false;
  isLoading = false;
  withSidebar = false;
  /**
   * Allows to display the learn more button. If the property is not provided, the button will not be displayed.
   * The property must be a translation key to an existing translation. If no translation is found, then the button will not be displayed.
   *
   * The translation can be html formatted and will be displayed in a side modal.
   */
  help;
  sidemodal = false;
  _backgroundColor = 'var(--geaui-pure-white)';
  set backgroundColor(color) {
    if (color === 'whitesmoke') {
      this._backgroundColor = 'var(--geaui-grey-06)';
    } else {
      this._backgroundColor = 'var(--geaui-pure-white)';
    }
  }
  get backgroundColor() {
    return this._backgroundColor;
  }
  get hasHelp() {
    const panelBody = this.helpAsPanel?.body;
    if (!panelBody) return false;
    const translation = this.translateService.instant(panelBody ?? '');
    return !!translation?.trim() && translation !== panelBody;
  }
  get helpAsPanel() {
    if (!this.help) return undefined;
    if (typeof this.help === 'string') {
      return {
        body: this.help
      };
    }
    return {
      title: this.help.title,
      body: this.help.body
    };
  }
  backArrowClicked = new EventEmitter();
  suffixIconClicked = new EventEmitter();
  constructor(translateService) {
    this.translateService = translateService;
  }
  openHelp() {
    this.sidemodal = !this.sidemodal;
  }
  closeHelp() {
    this.sidemodal = false;
  }
  static ɵfac = function PageHeaderComponent_Factory(t) {
    return new (t || PageHeaderComponent)(i0.ɵɵdirectiveInject(i1.TranslateService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PageHeaderComponent,
    selectors: [["geaui-page-header"]],
    inputs: {
      pageTitle: "pageTitle",
      hasBackArrow: "hasBackArrow",
      suffixIcon: "suffixIcon",
      suffixIconLoading: "suffixIconLoading",
      isLoading: "isLoading",
      withSidebar: "withSidebar",
      help: "help",
      backgroundColor: "backgroundColor"
    },
    outputs: {
      backArrowClicked: "backArrowClicked",
      suffixIconClicked: "suffixIconClicked"
    },
    ngContentSelectors: _c0,
    decls: 18,
    vars: 16,
    consts: [["titleLoading", ""], ["iconLoading", ""], [1, "geaui-grid", 3, "ngClass"], ["data-cy", "page-header", 1, "page-header", "geaui-col-desktop-xl-12", "geaui-col-desktop-xl-start-7", "geaui-col-desktop-lg-12", "geaui-col-desktop-md-12", "geaui-col-tablet-lg-12", "geaui-col-tablet-sm-12", "geaui-col-phone-lg-12", "geaui-col-phone-sm-12"], [1, "title-container"], ["class", "back-arrow", "file", "16px_arrow-left", "color", "black", 3, "click", 4, "ngIf"], ["class", "gea-font-heading-24 title", "data-cy", "title", "geauiTooltipOnEllipsisV2", "", 3, "pTooltip", 4, "ngIf", "ngIfElse"], [1, "help-container"], [1, "page-header-content"], [4, "ngIf"], [1, "border-bottom-grey"], [1, "sidemodal", 3, "closeSideModal", "modalTitle", "showCloseIcon", "show"], ["side-modal-body", "", 3, "innerHTML"], ["file", "16px_arrow-left", "color", "black", 1, "back-arrow", 3, "click"], ["data-cy", "title", "geauiTooltipOnEllipsisV2", "", 1, "gea-font-heading-24", "title", 3, "pTooltip"], [1, "help-container", 3, "click"], ["file", "16px_s-question", 1, "icon"], ["suffix", "", 1, "label"], ["class", "suffix-icon-container", "data-cy", "suffix-icon", 3, "click", 4, "ngIf", "ngIfElse"], ["data-cy", "suffix-icon", 1, "suffix-icon-container", 3, "click"], [1, "icon", 3, "fileSize", "file", "color"], [1, "icon-label", "gea-font-subline-16"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function PageHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div")(1, "header", 2)(2, "section", 3)(3, "div", 4);
        i0.ɵɵtemplate(4, PageHeaderComponent_geaui_icon_v2_4_Template, 1, 0, "geaui-icon-v2", 5)(5, PageHeaderComponent_div_5_Template, 3, 4, "div", 6)(6, PageHeaderComponent_Conditional_6_Template, 5, 3, "div", 7);
        i0.ɵɵelementStart(7, "div", 8);
        i0.ɵɵprojection(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(9, PageHeaderComponent_div_9_Template, 2, 2, "div", 9);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(10, "div", 10);
        i0.ɵɵtemplate(11, PageHeaderComponent_ng_template_11_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(13, PageHeaderComponent_ng_template_13_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(15, "geaui-side-modal-v2", 11);
        i0.ɵɵlistener("closeSideModal", function PageHeaderComponent_Template_geaui_side_modal_v2_closeSideModal_15_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.closeHelp());
        });
        i0.ɵɵelement(16, "div", 12);
        i0.ɵɵpipe(17, "translate");
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        let tmp_9_0;
        const titleLoading_r7 = i0.ɵɵreference(12);
        i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1, ctx.withSidebar));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.hasBackArrow);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.isLoading)("ngIfElse", titleLoading_r7);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.hasHelp ? 6 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.suffixIcon);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("modalTitle", (tmp_9_0 = ctx.helpAsPanel == null ? null : ctx.helpAsPanel.title) !== null && tmp_9_0 !== undefined ? tmp_9_0 : ctx.pageTitle)("showCloseIcon", true)("show", ctx.sidemodal);
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(17, 12, ctx.helpAsPanel == null ? null : ctx.helpAsPanel.body), i0.ɵɵsanitizeHtml);
      }
    },
    dependencies: [i2.NgClass, i2.NgIf, i3.TooltipOnEllipsisV2Directive, i4.IconComponent, i5.NgxSkeletonLoaderComponent, i6.Tooltip, i7.LinkV2Component, i8.SideModalV2Component, i1.TranslatePipe],
    styles: [".page-header[_ngcontent-%COMP%]{height:72px;max-height:72px;width:100%;display:inline-flex;align-items:center;padding-right:5px;gap:24px}.page-header[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{display:inline-flex;align-items:center;overflow:hidden;width:100%}.page-header[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin-right:20px}.page-header[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .page-header-content[_ngcontent-%COMP%]{flex-grow:1;margin-left:30px}.page-header[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .back-arrow[_ngcontent-%COMP%]{margin-right:16px}.page-header[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .back-arrow[_ngcontent-%COMP%]:hover{cursor:pointer}.page-header[_ngcontent-%COMP%]   .suffix-icon-container[_ngcontent-%COMP%]{display:inline-flex;align-items:center}.page-header[_ngcontent-%COMP%]   .suffix-icon-container[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-right:4px}.page-header[_ngcontent-%COMP%]   .suffix-icon-container[_ngcontent-%COMP%]   .icon-label[_ngcontent-%COMP%]{color:var(--geaui-vibrant-blue);font-weight:600;min-width:fit-content}.page-header[_ngcontent-%COMP%]   .suffix-icon-container[_ngcontent-%COMP%]:hover{cursor:pointer}.border-bottom-grey[_ngcontent-%COMP%]{width:100%;border-bottom:2px solid var(--geaui-grey-03)}.help-container[_ngcontent-%COMP%]{cursor:pointer;padding:4px}.help-container[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{padding:4px}.help-container[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-left:4px}.sidemodal[_ngcontent-%COMP%]{position:fixed;top:60px;right:0;width:fit-content;z-index:10;height:calc(100% - 60px)}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-page-header',
      template: "<div [style.background-color]=\"backgroundColor\">\n  <header class=\"geaui-grid\" [ngClass]=\"{ 'geaui-sidebar-grid': withSidebar }\">\n    <section\n      class=\"page-header geaui-col-desktop-xl-12 geaui-col-desktop-xl-start-7 geaui-col-desktop-lg-12 geaui-col-desktop-md-12 geaui-col-tablet-lg-12 geaui-col-tablet-sm-12 geaui-col-phone-lg-12 geaui-col-phone-sm-12\"\n      data-cy=\"page-header\">\n      <div class=\"title-container\">\n        <geaui-icon-v2\n          class=\"back-arrow\"\n          *ngIf=\"hasBackArrow\"\n          (click)=\"backArrowClicked.emit()\"\n          file=\"16px_arrow-left\"\n          color=\"black\">\n        </geaui-icon-v2>\n        <div\n          class=\"gea-font-heading-24 title\"\n          *ngIf=\"!isLoading; else titleLoading\"\n          [pTooltip]=\"pageTitle\"\n          data-cy=\"title\"\n          geauiTooltipOnEllipsisV2>\n          {{ pageTitle | translate }}\n        </div>\n        @if (hasHelp) {\n          <div class=\"help-container\" (click)=\"openHelp()\">\n            <geaui-icon-v2 class=\"icon\" file=\"16px_s-question\">\n              <geaui-link-v2 class=\"label\" suffix>\n                {{ 'X.BUTTON.LEARN_MORE' | translate }}\n              </geaui-link-v2>\n            </geaui-icon-v2>\n          </div>\n        }\n        <div class=\"page-header-content\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div *ngIf=\"suffixIcon\">\n        <div\n          class=\"suffix-icon-container\"\n          *ngIf=\"!suffixIconLoading; else iconLoading\"\n          (click)=\"suffixIconClicked.emit()\"\n          data-cy=\"suffix-icon\">\n          <geaui-icon-v2 class=\"icon\" [fileSize]=\"16\" [file]=\"suffixIcon.file\" [color]=\"suffixIcon.color\"></geaui-icon-v2>\n          <div class=\"icon-label gea-font-subline-16\">{{ suffixIcon?.label | translate }}</div>\n        </div>\n      </div>\n    </section>\n  </header>\n</div>\n\n<div class=\"border-bottom-grey\"></div>\n\n<ng-template #titleLoading>\n  <ngx-skeleton-loader [theme]=\"{ height: '30px', width: '200px', margin: 0 }\" count=\"1\" appearance=\"line\"></ngx-skeleton-loader>\n</ng-template>\n\n<ng-template #iconLoading>\n  <ngx-skeleton-loader\n    [theme]=\"{ height: '30px', width: '100px', margin: '0 25px' }\"\n    count=\"1\"\n    appearance=\"line\"></ngx-skeleton-loader>\n</ng-template>\n\n<geaui-side-modal-v2\n  class=\"sidemodal\"\n  [modalTitle]=\"helpAsPanel?.title ?? pageTitle\"\n  [showCloseIcon]=\"true\"\n  [show]=\"sidemodal\"\n  (closeSideModal)=\"closeHelp()\">\n  <div [innerHTML]=\"helpAsPanel?.body | translate\" side-modal-body></div>\n</geaui-side-modal-v2>\n",
      styles: [".page-header{height:72px;max-height:72px;width:100%;display:inline-flex;align-items:center;padding-right:5px;gap:24px}.page-header .title-container{display:inline-flex;align-items:center;overflow:hidden;width:100%}.page-header .title-container .title{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin-right:20px}.page-header .title-container .page-header-content{flex-grow:1;margin-left:30px}.page-header .title-container .back-arrow{margin-right:16px}.page-header .title-container .back-arrow:hover{cursor:pointer}.page-header .suffix-icon-container{display:inline-flex;align-items:center}.page-header .suffix-icon-container .icon{margin-right:4px}.page-header .suffix-icon-container .icon-label{color:var(--geaui-vibrant-blue);font-weight:600;min-width:fit-content}.page-header .suffix-icon-container:hover{cursor:pointer}.border-bottom-grey{width:100%;border-bottom:2px solid var(--geaui-grey-03)}.help-container{cursor:pointer;padding:4px}.help-container .icon{padding:4px}.help-container .label{margin-left:4px}.sidemodal{position:fixed;top:60px;right:0;width:fit-content;z-index:10;height:calc(100% - 60px)}\n"]
    }]
  }], () => [{
    type: i1.TranslateService
  }], {
    pageTitle: [{
      type: Input
    }],
    hasBackArrow: [{
      type: Input
    }],
    suffixIcon: [{
      type: Input
    }],
    suffixIconLoading: [{
      type: Input
    }],
    isLoading: [{
      type: Input
    }],
    withSidebar: [{
      type: Input
    }],
    help: [{
      type: Input
    }],
    backgroundColor: [{
      type: Input
    }],
    backArrowClicked: [{
      type: Output
    }],
    suffixIconClicked: [{
      type: Output
    }]
  });
})();
